import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CREDITNOTESDETAILS_INIT_ACTION,
  FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION,
  FETCH_CREDITNOTESDETAILS_FAIL_ACTION
  // ADD_CREDITNOTES_INIT_ACTION,
  // ADD_CREDITNOTES_SUCCESS_ACTION,
  // ADD_CREDITNOTES_FAIL_ACTION
} from "./action";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var history = createBrowserHistory();

var history = createBrowserHistory();

function* fetchCreditNotes(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  let pageno = (!value.value)? 1: (value.value.page === undefined? 1: value.value.page);
  let search = (!value.value)? "":(value.value.search === ""? "": value.value.search);
  let filter = (!value.value)? "":(value.value.filter === ""? "": value.value.filter);

  try {
    const res = yield fetch(
      `${appConfig.ip}/creditNotes?crdtFrom=${distributorProfId}&limit=10&page=${pageno}&search=${search}&status=${filter}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CREDITNOTESDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* CreditNotesActionWatcher() {
  yield takeEvery(FETCH_CREDITNOTESDETAILS_INIT_ACTION, fetchCreditNotes);
}